import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
// import { FormControl, MenuItem, Select } from '@mui/material';
// import React, { Dispatch, SetStateAction } from 'react';

// type props = {
//   module: any;
//   page: number;
//   onPageChange: (newPage: number) => void;
//   totalPages: number;
//   totalCount: number;
//   setPage: Dispatch<SetStateAction<number>>;
// };

// export default function Pagination({
//   module,
//   page,
//   onPageChange,
//   totalPages,
//   setPage,
//   totalCount,
// }: props) {
//   const startIndex = (page - 1) * 10 + 1;
//   const endIndex = Math.min(startIndex + 10 - 1, totalCount);
//   return (
//     <div className="pagination_wrp">
//       <p>
//         Showing <strong>{module?.length ? `${module?.length}` : 0}</strong> from
//         <strong> {totalCount || ''}</strong> data
//       </p>
//       <div className="pagination_number">
//         {totalPages > 5 ? (
//           <FormControl fullWidth className="all_page">
//             <Select
//               className="dropse"
//               labelId="demo-simple-select-label"
//               id="demo-simple-select"
//               inputProps={{
//                 'aria-label': 'Without label',
//               }}
//               displayEmpty
//               value={page}
//               onChange={(pages: any) => setPage(pages.target.value)}
//             >
//               <MenuItem value="" disabled>
//                 Select
//               </MenuItem>
//               {Array.from({ length: totalPages }).map((_, index) => (
//                 <MenuItem key={index + 1} value={index + 1}>
//                   {index + 1}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         ) : null}
//         <button
//           className="page_icon first_icon"
//           onClick={() => onPageChange(page - 1)}
//           disabled={page === 1}
//         >
//           <KeyboardDoubleArrowLeftIcon className="mat_icon" />
//         </button>
//         <ul className="pagination_list">
//           {totalPages > 4
//             ? Array.from({ length: totalPages })
//                 .slice(0, 3)
//                 .map((_, index) => (
//                   <li
//                     className={page === index + 1 ? 'active' : ''}
//                     key={index}
//                     onClick={() => onPageChange(index + 1)}
//                     // disabled={page === index + 1}
//                     // type="button"
//                   >
//                     {index + 1}
//                   </li>
//                 ))
//                 .concat(
//                   <span key="ellipsis" className="ellipsis" style={{ color: 'black' }}>
//                     ...
//                   </span>,
//                   <li
//                     className="active"
//                     // type="button"
//                     style={{
//                       display: page < 4 || page === totalPages ? 'none' : undefined,
//                     }}
//                     key={totalPages}
//                   >
//                     {page}
//                   </li>,
//                   <li
//                     className={page === totalPages ? 'active' : 'inActv'}
//                     key={totalPages}
//                     // type="button"
//                     onClick={() => onPageChange(totalPages)}
//                     // disabled={page === totalPages}
//                   >
//                     {totalPages}
//                   </li>
//                 )
//             : Array.from({ length: totalPages }).map((_, index) => (
//                 <li
//                   className={page === index + 1 ? 'active' : 'inActv'}
//                   // type="button"
//                   key={index}
//                   onClick={() => onPageChange(index + 1)}
//                   // disabled={page === index + 1}
//                 >
//                   {index + 1}
//                 </li>
//               ))}
//         </ul>
//         {/* <ul className="pagination_list">
//           <li className="active">1</li>
//           <li>2</li>
//           <li>3</li>
//           <li>4</li>
//         </ul> */}
//         <button
//           className="page_icon"
//           onClick={() => onPageChange(page + 1)}
//           disabled={page === totalPages}
//         >
//           <KeyboardDoubleArrowRightIcon className="mat_icon" />
//         </button>
//       </div>
//     </div>
//   );
// }

import { Box, Button } from "@mui/material";

interface CustomPaginationProps {
  totalPages?: number;
  currentPage?: number; // zero-based index
  onPageChange?: (page: number) => void;
  count?: number;
  pageSize?: number;
}

const CustomPagination = ({
  totalPages = 1,
  currentPage = 0,
  onPageChange = () => {},
  count = 0,
  pageSize = 10,
}: CustomPaginationProps) => {
  const getPageNumbers = () => {
    const maxVisible = 4;
    const start = Math.max(0, currentPage - Math.floor(maxVisible / 2));
    const end = Math.min(totalPages, start + maxVisible);

    return Array.from({ length: end - start }, (_, i) => start + i);
  };

  const showingStart = currentPage * pageSize + 1;
  const showingEnd = Math.min((currentPage + 1) * pageSize, count);

  return (
    <div className="pagination">
      <p>
        Showing <strong> 1-10</strong> from <strong> {count} </strong>data
      </p>
      <Box display="flex" alignItems="center">
        <Button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 0}
          className="page-btn"
        >
          <KeyboardDoubleArrowLeftIcon className="mat_icon" />
        </Button>

        <div className="count_page">
          {getPageNumbers().map((pageIndex) => (
            <Button
              key={pageIndex}
              variant={currentPage === pageIndex ? "contained" : "outlined"}
              onClick={() => onPageChange(pageIndex)}
              className={`page-btn ${currentPage === pageIndex ? "active" : ""}`}
            >
              {pageIndex + 1}
            </Button>
          ))}
        </div>

        <Button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages - 1}
          className="page-btn"
        >
          <KeyboardDoubleArrowLeftIcon className="mat_icon" />
        </Button>
      </Box>
    </div>
  );
};

export default CustomPagination;
